'use client'
import { type FC } from 'react'
import styled from 'styled-components'
import { useSession, useTranslator } from '@/hooks'
import type { TypeCmsPriceListRecord } from '@/schema'
import { currencyFormatter, DY_GUEST_CART_ALLOWED } from '@/utils'
import { presets } from '@/styles'

type Props = {
  data: TypeCmsPriceListRecord
  pricePer?: 'unit' | 'box' | 'kg'
}

export const Price: FC<Props> = ({ data, pricePer }) => {
  const { salePrice, retailPrice } = data
	const { user } = useSession()
  const { t } = useTranslator()
  const pricePerText = pricePer ? t(`project.product.price_per.${pricePer}`) : null

  if (!user && !DY_GUEST_CART_ALLOWED) return null

  return (
    <PriceP className='price'>
      {retailPrice > salePrice && (
        <span>
          {currencyFormatter({ price: retailPrice, round: false })}
          {pricePerText && <small>{pricePerText}</small>}
        </span>
      )}
      <span>
        {currencyFormatter({ price: salePrice, round: false })}
        {pricePerText && <small>{pricePerText}</small>}
      </span>
    </PriceP>
  )
}

export const PriceP = styled.p`
  ${presets.font12_3()}
  display: flex;
  flex-direction: column;
  color: var(--color-text);

  span {
    color: var(--color-gold);

    /* retail -> Discounted */
    &:first-child {
      &:not(:last-child) {
        opacity: .65;
        text-decoration: line-through;
      }
    }

    /* sale price */
    &:last-child {
      ${presets.font26_3()}
    }
  }

  small {
    ${presets.font15_3()}
  }
`
